<script setup>
import { Link } from '@inertiajs/inertia-vue3';
</script>
<template>
<footer>
        <div class="footer-superior">
          <div class="container">
            <div class="row justify-content-center align-items-end">
              <div class="col-12 justify-content-center mb-2 text-center">
                <a class="mx-auto" href="https://www.editorialox.com/" target="_blank"><img class="mx-auto d-block"   style="width: 80px; height: 80px" src="/img/premio.png"></a>
                <p>Web premiada con el Premio Internacional OX</p>
              </div>
              <div class="col-12 col-md-6">
                <div class="footer-contacto">
                  <div class="footer-telefono">
                    <Link href="/te_escuchamos" class="mr-2">Te Escuchamos</Link>
                    | <span class="ml-2"> Atención Ciudadana: </span>
                    <a :href="'tel:'+$telefono">{{ $telefono }}</a>
                  </div>
                  <ul class="footer-sociales">
                    <li>
                      <a href="https://www.facebook.com/santiago.gob.mx" target="_blank">
                        <img src="/img/icono-social-facebook-blanco.svg" alt="Facebook">
                      </a>
                    </li>
                    <li>
                      <a href="https://twitter.com/stgogob" target="_blank">
                        <img src="/img/icono-social-twitter-blanco.svg" alt="Twitter">
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/santiago_nuevoleon" target="_blank">
                        <img src="/img/icono-social-instagram-blanco.svg" alt="Instagram">
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/channel/UCs8fb3ANuESOApF1hzZZENw" target="_blank">
                        <img src="/img/icono-social-youtube-blanco.svg" alt="YouTube">
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-inferior">
          <div class="container">
            <div class="row justify-content-between">
              <div class="col-lg-6">
                <ul class="footer-legales">
                  <li class="active"><a href="/descargas/avisodeprivacidad.pdf" target="_blank">Aviso de Privacidad</a></li>
                </ul>
              </div>
              <div class="col-lg-6 col-xl-5">
                <div class="footer-copyright">2023 © Municipio de Santiago. <span>Todos los derechos reservados.</span></div>
              </div>
            </div>
          </div>
        </div>
      </footer>
</template>
<script>
export default {
}
</script>
<style>

</style>
